/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import React from 'react';
import { Icon, Button, Popup } from 'semantic-ui-react';

const iconStyle = { lineHeight: 1, height: '1em', width: '1em', fontSize: '1em', margin: 0 };

// expected props
// - compactMode (bool) — true when the compact grid view is active
// - onCompactToggle (function) — called when the inactive option is selected
export default function CatalogueViewToggle({ compactMode = false, onCompactToggle }) {
  const isFullView = !compactMode;
  const isCompactView = compactMode;

  return (
    <Button.Group size="small" className="workspace-view-toggle">
      <Popup
        trigger={
          <Button
            icon
            basic={!isFullView}
            color="blue"
            onClick={isFullView ? undefined : onCompactToggle}
            className="workspace-header-btn"
            aria-label="List View"
            aria-pressed={isFullView}
          >
            <Icon name="th list" style={iconStyle} />
          </Button>
        }
        content="List View"
        position="top center"
        mouseEnterDelay={500}
        inverted
      />
      <Popup
        trigger={
          <Button
            icon
            basic={!isCompactView}
            color="blue"
            onClick={isCompactView ? undefined : onCompactToggle}
            className="workspace-header-btn"
            aria-label="Compact Grid"
            aria-pressed={isCompactView}
          >
            <Icon name="th large" style={iconStyle} />
          </Button>
        }
        content="Compact Grid"
        position="top center"
        mouseEnterDelay={500}
        inverted
      />
    </Button.Group>
  );
}
